
<div class="input-group mb-3">
  <span class="input-group-text" id="inputGroup-sizing-default">Detalle</span>
  <input id="Detalle" [(ngModel)]="motivo" type="text" class="form-control" aria-label="Detalle"
    aria-describedby="inputGroup-sizing-default">
</div>
<div class="d-grid gap-2 d-md-flex justify-content-md-end">

  <button class="btn btn-primary" type="button" (click)="enviar()" [mat-dialog-close]="motivo">Cargar</button>
  <button class="btn btn-primary" type="button" (click)="enviar()" [mat-dialog-close]="''">Cancelar</button>
</div>
